import _lib from '../_lib';
import active from './active/index';
import {MedAdminNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'medadmin';
  let activations = [
    {
      name: 'medadmin',
      test: api.messageIs(MedAdminNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};